import { pipe } from 'ramda';
import { createSelector } from 'reselect';

import { IRootState } from '../../../store/root.types';

import { RedeemCredentialType } from './redeem.types';

const pathToRedeemState = (state: IRootState) => state.redeem;

export const getProduct = pipe(pathToRedeemState, state => state.product);

export const getCredentials = pipe(pathToRedeemState, state => state.credentials);

export const getRedemption = pipe(pathToRedeemState, state => state.redemption);

export const getIsLoading = pipe(pathToRedeemState, state => state.isLoading);

export const getIsLoaded = pipe(pathToRedeemState, state => state.isLoaded);

export const getCustomLogo = pipe(pathToRedeemState, state => state.customLogo);

export const getCredentialPartials = createSelector(getCredentials, credentials => ({
  codes: credentials.filter(({ credentialType }) =>
    [
      RedeemCredentialType.CardNumber,
      RedeemCredentialType.SecretCode,
      RedeemCredentialType.RewardSecurityCode,
      RedeemCredentialType.Pin,
      RedeemCredentialType.Code,
      RedeemCredentialType.CodePin,
      RedeemCredentialType.CardCode,
    ].includes(credentialType),
  ),
  url: credentials.find(({ credentialType }) =>
    [
      RedeemCredentialType.BypassUrl,
      RedeemCredentialType.RedemptionUrl,
      RedeemCredentialType.RewardSecurityUrl,
      RedeemCredentialType.Url,
      RedeemCredentialType.UrlPin,
      RedeemCredentialType.UrlPinTogether,
      RedeemCredentialType.LandingPage,
    ].includes(credentialType),
  ),
}));
